import './TitleBar.less';
import React from 'react';
import Button from '../../../../bootstrap/components/button/Button';
import __ from '../../../i18n';

export default function TitleBar({course, setShowsMenu}) {
    return (
        <div className="title-bar">
            <div className="title">
                {course.name}
            </div>
            <div className="actions">
                <Button
                    title={__('Lessons list')}
                    appearance="outline-primary"
                    size="small"
                    onClick={setShowsMenu}
                />
            </div>
        </div>
    );
}
